import {
  DvFormElementParams,
  DvTextareaElement,
  DvTextareaElementParams,
  FormType,
} from '@devinco/ui/dds';
import { FormElementExtra } from './form.element';

export class VtTextareaElement<
  TForm extends FormType = FormType,
  TFormContext = any,
> extends DvTextareaElement<TForm, TFormContext> {
  constructor(params: VtTextareaElementParams<TForm, TFormContext>) {
    super(params);
    params.elementParams ??= {};
    params.extra ??= {};
  }
}

export interface VtTextareaElementParams<
  TForm extends FormType,
  TFormContext = any,
> extends DvFormElementParams<{
  TForm: TForm;
  TFormContext: TFormContext;
  TElementParams: DvTextareaElementParams;
}> {
  extra?: FormElementExtra;
}
